import _ from 'underscore';
import $ from 'jquery';

function ApiNicknameValidationRequest(options) {
    this.makingRequest = false;

    this.options = _.extend({
        onErrors: function(errors) {},
        onHttpError: function() {},
        onSuccess: function() {},
        onBanned: function() {},
        onExists: function(spa_id) {},
        onSuggestions: function(suggestions) {},
        onHttpStart: function() {},
        templateVariable: '%nickname%'
    }, options);
}

ApiNicknameValidationRequest.prototype.make = function(nickname, data) {
    var options, completeUrl;

    if (this.makingRequest) {
        return false;
    }

    options = this.options;
    completeUrl = options.url.replace(
        options.templateVariable,
        encodeURIComponent(nickname)
    );

    return $.ajax(completeUrl, {
        type: this._detectMethod(data),
        dataType: 'json',
        cache: false,
        data: data || {},
        timeout: options.timeout || 0,
        success: function(data) {
            if (data.spa_id) {
                options.onExists(data.spa_id);
            }
            if (data.banned) {
                options.onBanned();
            }
            if ((data.spa_id || data.banned) && _.isArray(data.suggestions) && !_.isEmpty(data.suggestions)) {
                options.onSuggestions(data.suggestions);
            }
            if (!data.banned && !data.spa_id) {
                options.onSuccess(data);
            }
        },
        error: function(request) {
            if (request.status === 409) {
                data = $.parseJSON(request.responseText);
                options.onErrors(data['__all__']);
            } else {
                options.onHttpError();
            }
        },
        complete: _.bind(function() {
            this.makingRequest = false;
        }, this),
        beforeSend: _.bind(function() {
            this.makingRequest = true;
            options.onHttpStart.call(this);
        }, this)
    });
};

ApiNicknameValidationRequest.prototype._detectMethod = function(data) {
    data = data || {};

    if (typeof(data) === 'object') {
        var size = _.keys(data).length;

        if ('suggestions' in data && size === 1) {
            return 'GET';
        } else if (size > 0) {
            return 'POST';
        }
    }
    return 'GET';
};

export default ApiNicknameValidationRequest;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/clientvalidation/nickname_validation.js